import React, { useEffect } from 'react'
import ReactMapGL, { WebMercatorViewport, FlyToInterpolator } from 'react-map-gl'
import useMedia from 'use-media'

import 'mapbox-gl/dist/mapbox-gl.css'

import { getBoundingBox } from '../../helpers'

import NavigationControl from '../../atoms/Map/NavigationControl'
import ApartmentMarker from '../../molecules/Map/ApartmentMarker'
import SubmarketMarker from '../../molecules/Map/SubmarketMarker'

import ApartmentCardPopup from './ApartmentCardPopup'

const MAPBOX_API_TOKEN =
  process.env.STORYBOOK_MAPBOX_API_TOKEN || process.env.GATSBY_MAPBOX_API_TOKEN

const defaultProps = {
  width: '100%',
  height: '100%',
  mapboxApiAccessToken: MAPBOX_API_TOKEN,
  mapStyle: 'mapbox://styles/texaspacm/cjjgogt6h2dhu2rpsz0gyhxh0',
}

const Map = (
  {
    hideSubmarkets,
    submarkets = [],
    apartments = [],
    highlight,
    popup,
    showPopup,
    closePopup,
    viewport,
    setViewport,
    children,
    ...props
  },
  ref,
) => {
  const { width, height } = viewport
  const hash = apartments.map(a => a.id).join('-')
  const isMobile = useMedia({ maxWidth: '767.9px' })

  // FIXME: react-hook warning - missing apartments, setViewport, viewport in dependency array
  useEffect(() => {
    if (width && height && apartments.length > 1) {
      const bbox = getBoundingBox(apartments.map(apartment => apartment.coordinates))
      const newViewport = new WebMercatorViewport({ width, height }).fitBounds(bbox, {
        padding: 100,
      })
      const withTransition = isMobile ? {} : {
        transitionDuration: 1000,
        transitionInterpolator: new FlyToInterpolator(),
      }
      setViewport({
        ...viewport,
        ...newViewport,
        ...withTransition,
      })
    } else if (apartments.length === 1) {
      const [
        {
          coordinates: { lat, lng },
        },
      ] = apartments
      const newViewport = {
        latitude: lat,
        longitude: lng,
        zoom: 10,
      }
      const withTransition = isMobile ? {} : {
        transitionDuration: 1000,
        transitionInterpolator: new FlyToInterpolator(),
      }
      setViewport({
        ...viewport,
        ...newViewport,
        ...withTransition,
      })
    }
  }, [width, height, hash])

  return (
    <ReactMapGL ref={ref} {...defaultProps} {...props} {...viewport} onViewportChange={setViewport}>
      <NavigationControl onViewportChange={setViewport} />
      {children}
      {hideSubmarkets
        ? null
        : submarkets.map((submarket, i) => <SubmarketMarker key={i} submarket={submarket} />)}
      {apartments.map((apartment, i) => (
        <ApartmentMarker
          key={i}
          apartment={apartment}
          onClick={() => showPopup(apartment)}
          highlight={highlight && highlight.id === apartment.id}
        />
      ))}
      {popup ? <ApartmentCardPopup apartment={popup} onClose={closePopup} /> : null}
    </ReactMapGL>
  )
}

export default React.forwardRef(Map)
